import { useState } from 'react';
import { loyaltyFaqs } from '@/mocks/loyalty';

const LoyaltyFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const color = '#00f5ff';

  return (
    <section className="py-20 px-4 md:px-8 lg:px-12" style={{ background: '#050508' }}>
      <div className="max-w-4xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12">
          <p className="font-mono text-xs tracking-[0.3em] mb-2" style={{ color }}>ВОПРОСЫ И ОТВЕТЫ</p>
          <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white mb-3">
            ПРАВИЛА ПРОГРАММЫ
          </h2>
          <p className="font-mono text-sm text-white/40">
            Всё, что нужно знать об условиях бонусной программы
          </p>
        </div>

        {/* FAQ accordion */}
        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {loyaltyFaqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden transition-all duration-300"
              style={{
                border: `1px solid ${openIndex === i ? color + '40' : 'rgba(255,255,255,0.06)'}`,
                background: openIndex === i ? `${color}05` : 'rgba(255,255,255,0.02)',
              }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 cursor-pointer text-left"
              >
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <div
                    className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 font-orbitron font-black text-xs transition-all duration-300"
                    style={{
                      background: openIndex === i ? color : 'rgba(255,255,255,0.05)',
                      color: openIndex === i ? '#050508' : 'rgba(255,255,255,0.3)',
                    }}
                  >
                    {String(i + 1).padStart(2, '0')}
                  </div>
                  <span className="font-orbitron font-bold text-sm text-white/85 leading-snug" itemProp="name">
                    {faq.q}
                  </span>
                </div>
                <div
                  className="w-7 h-7 flex items-center justify-center rounded-full shrink-0 ml-4 transition-all duration-300"
                  style={{
                    background: openIndex === i ? `${color}20` : 'rgba(255,255,255,0.04)',
                    border: `1px solid ${openIndex === i ? color + '40' : 'rgba(255,255,255,0.08)'}`,
                    transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                >
                  <i className="ri-arrow-down-s-line text-sm" style={{ color: openIndex === i ? color : 'rgba(255,255,255,0.3)' }} />
                </div>
              </button>

              {openIndex === i && (
                <div
                  className="px-6 pb-6"
                  style={{ borderTop: `1px solid ${color}15` }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p className="font-mono text-sm text-white/55 leading-relaxed pt-4 pl-11" itemProp="text">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Download agreement */}
        <div className="mt-8 flex items-center justify-center">
          <a
            href="#"
            rel="nofollow"
            className="flex items-center gap-2 font-mono text-xs cursor-pointer transition-all duration-300"
            style={{ color: 'rgba(255,255,255,0.3)' }}
            onMouseEnter={e => (e.currentTarget as HTMLElement).style.color = color}
            onMouseLeave={e => (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.3)'}
          >
            <i className="ri-file-pdf-line" />
            Договор об участии в программе лояльности (PDF)
          </a>
        </div>
      </div>
    </section>
  );
};

export default LoyaltyFaq;
